import { css } from '@emotion/css';
import { ChipItem } from 'models/txcb-model';
import { forwardRef } from 'react';
import './chips-active.scss';
import chipSelect from 'assets/images/chips/chip-select.png';

const chipInit: ChipItem[] = [
    {
        txt: '1K',
        val: 1000,
        isActive: false,
        icon: 'chip1.png',
    },
    {
        txt: '10K',
        val: 10000,
        isActive: false,
        icon: 'chip2.png',
    },
    {
        txt: '50K',
        val: 50000,
        isActive: false,
        icon: 'chip3.png',
    },
    {
        txt: '100K',
        val: 100000,
        isActive: false,
        icon: 'chip4.png',
    },
    {
        txt: '500K',
        val: 500000,
        isActive: false,
        icon: 'chip5.png',
    },
    {
        txt: '5M',
        val: 5000000,
        isActive: false,
        icon: 'chip6.png',
    },
    {
        txt: '10M',
        val: 10000000,
        isActive: false,
        icon: 'chip7.png',
    },
    {
        txt: '50M',
        val: 50000000,
        isActive: false,
        icon: 'chip8.png',
    },
];

interface Props {
    valueActive: number;
    onSelect: (chip: ChipItem) => void;
    slideItem?: number;
}
function ChipBaucua(props: Props, ref: any) {
    const { valueActive, onSelect } = props;
    return (
        <div className={styles.chipContainer}>
            {chipInit.map((item, index) => (
                <button
                    key={index}
                    type="button"
                    className={`chip-item ${item.val === valueActive ? 'active' : ''}`}
                    onClick={() => onSelect(item)}
                    ref={(el) => (ref.current[index] = el)}
                    datatype={String(item.val)}
                >
                    <img src={require(`assets/images/chips/${item.icon}`)} alt="coin" />
                    <p>{item.txt}</p>
                </button>
            ))}
        </div>
    );
}

export default forwardRef(ChipBaucua);

const styles = {
    chipContainer: css`
    display: flex;
        .active:before {
            content: "";
            position: absolute;
            z-index: 1;
            width: 56px;
            height: 56px;
            background: url(${chipSelect}) center / contain no-repeat;
            top: -1px;
            left: -1px;
            --webkit-animation: spinChip 5s infinite;
            -webkit-animation: 5s infinite spinChip;
            animation: 5s infinite spinChip;
        }
        .chip-item {
            padding: 6px;
            position: relative;
            border-radius: 40px;

            p {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 14px;
                font-weight: 800;
                color: #fff;
            }
            @-webkit-keyframes spinChip {
                0%,
                100% {
                    -webkit-transform: rotate(0);
                    transform: rotate(0);
                }

                50% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                }
            }

            @keyframes spinChip {
                0%,
                100% {
                    -webkit-transform: rotate(0);
                    transform: rotate(0);
                }

                50% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                }
            }
        }
    `,
};
